import React, { Component, ErrorInfo, ReactNode } from "react";
import { Copy } from "lucide-react";

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
    error: Error | null;
    errorInfo: ErrorInfo | null;
}

class ErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false,
        error: null,
        errorInfo: null
    };

    public static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error, errorInfo: null };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error("Uncaught error:", error, errorInfo);
        this.setState({ error, errorInfo });
    }

    public render() {
        if (this.state.hasError) {
            return (
                <div className="p-8 bg-red-50 border-2 border-red-500 rounded-xl m-4 text-red-900 overflow-auto max-h-screen">
                    <h1 className="text-2xl font-black mb-4">¡ALERTA DE ERROR!</h1>
                    <p className="font-bold mb-2">Por favor copia y pega esto en el chat para arreglarlo:</p>
                    <div className="bg-white p-4 rounded border border-red-200 font-mono text-xs whitespace-pre-wrap">
                        {this.state.error && this.state.error.toString()}
                        <br />
                        {this.state.errorInfo && this.state.errorInfo.componentStack}
                    </div>
                    <div className="flex gap-4 mt-6">
                        <button
                            onClick={() => {
                                const errorText = `${this.state.error?.toString()}\n\nSTACK TRACE:\n${this.state.errorInfo?.componentStack}`;
                                navigator.clipboard.writeText(errorText);
                                const btn = document.getElementById('btn-copy-error');
                                if (btn) {
                                    const originalText = btn.innerHTML;
                                    btn.innerHTML = "✅ ¡Copiado!";
                                    setTimeout(() => { if (btn) btn.innerHTML = originalText; }, 2000);
                                }
                            }}
                            id="btn-copy-error"
                            className="px-6 py-2 bg-slate-800 text-white font-bold rounded-lg hover:bg-slate-900 transition-all flex items-center gap-2"
                        >
                            <Copy size={18} />
                            Copiar Error
                        </button>
                        <button
                            onClick={() => window.location.reload()}
                            className="px-6 py-2 bg-red-600 text-white font-bold rounded-lg hover:bg-red-700 transition-all"
                        >
                            Recargar Página
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
